import { Action } from 'redux';

import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ListResult } from '../../ts/fetchers/ListResult';
import { isHomeAddFavoriteSucceededAction, ishomeFetchFavoritesSucceededAction, ishomeFetchPopularSucceededAction, ishomeFetchRecentsSucceededAction, ishomeFetchSharedWithMeSucceededAction, isHomeRemoveFavoriteSucceededAction } from '../actions/HomeActions';
import { ChannelState } from '../types/HomeTypes';
import { ContentKeyPrefix, normalizedContentKey } from './NormalizedContentReducer';

const initialChannelState: ChannelState = {
  isFetching: true, //TODO: isFetching should be false in initialState, and should be set to true by redux reducer that listens to new HomeFavoritesRequested action
  items: [],
};

function deriveChannelStateFromResult(result: ListResult<IContentInfo>, prefix?: ContentKeyPrefix): ChannelState {
  const derivedChannelState: ChannelState = {
    items: result.items.map((item: IContentInfo) => normalizedContentKey(item.id, item.contentType, prefix)),
    isFetching: false,
  };

  return derivedChannelState;
}

export function favoritesContentReducer(previousState: ChannelState = {...initialChannelState}, action: Action) {
  if (ishomeFetchFavoritesSucceededAction(action)) {
    return deriveChannelStateFromResult(action.result);
  }
  if(isHomeAddFavoriteSucceededAction(action)) {
    const { contentId, contentType } = action;
    const key: string = normalizedContentKey(contentId, contentType);
    // if item already exists in the favorites list, prevent duplicate addition
    if(previousState.items.some((favoriteItemKey: string) => favoriteItemKey === key)) {
      return previousState;
    }
    return {
      ...previousState,
      items: [normalizedContentKey(contentId, contentType), ...previousState.items]
    };
  }
  if(isHomeRemoveFavoriteSucceededAction(action)) {
    const { contentId, contentType } = action;
    const key: string = normalizedContentKey(contentId, contentType);
    return {
      ...previousState,
      items: previousState.items.filter((contentId: string) => contentId !== key)
    };
  }
  return previousState;
}

export function recentsContentReducer(previousState: ChannelState = {...initialChannelState}, action: Action) {
  if (ishomeFetchRecentsSucceededAction(action)) {
    return deriveChannelStateFromResult(action.result);
  }
  return previousState;
}

export function popularContentReducer(previousState: ChannelState = {...initialChannelState}, action: Action) {
  if (ishomeFetchPopularSucceededAction(action)) {
    return deriveChannelStateFromResult(action.result);
  }
  return previousState;
}

export function sharedWithMeContentReducer(previousState: ChannelState = {...initialChannelState}, action: Action) {
  if (ishomeFetchSharedWithMeSucceededAction(action)) {
    return deriveChannelStateFromResult(action.result, ContentKeyPrefix.sharedWithMe);
  }
  return previousState;
}
